/**
 * Shared Password Configuration
 * Used by both client and server to ensure consistency
 */

export const PASSWORD_CONFIG = {
  MIN_LENGTH: 12,
  REQUIREMENTS: {
    LENGTH: 'length',
    UPPERCASE: 'uppercase', 
    LOWERCASE: 'lowercase',
    NUMBER: 'number',
    SPECIAL: 'special',
  },
  STRENGTH_THRESHOLDS: {
    STRONG: 80,   // 4/5 requirements (80%)
    MEDIUM: 60,   // 3/5 requirements (60%)
    FAIR: 40,     // 2/5 requirements (40%)
  },
  // Regex patterns used for validation
  PATTERNS: {
    UPPERCASE: /[A-Z]/,
    LOWERCASE: /[a-z]/,
    NUMBER: /\d/,
    SPECIAL: /[^a-zA-Z0-9]/,
  }
};

// For CommonJS compatibility (Node.js server)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { PASSWORD_CONFIG };
}

export default PASSWORD_CONFIG;
